<script>
import moment from "moment";
import Modal from "./Modal.vue";
import ConvertToRequisitionModal from "./ConvertToRequisitionModal.vue";

export default {
  components: {
    Modal,
    ConvertToRequisitionModal
  },
  props: {
    requisitions: {
      type: Array,
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
  },

  computed: {
    filteredRequisitions() {
      return this.requisitions
        .filter(
          (req) =>
            req.person_specification.business_line.company.title
              .toLowerCase()
              .includes(this.textFilter.toLowerCase()) ||
            req.person_specification.title
              .toLowerCase()
              .includes(this.textFilter.toLowerCase()) ||
            req.contract_type.title
              .toLowerCase()
              .includes(this.textFilter.toLowerCase())
        )
        .filter(
          (req) =>
            this.recruiterIdFilter === null ||
            req.creator_id === this.recruiterIdFilter
        )
        .filter(
          (req) =>
            this.companyIdFilter === null ||
            req.person_specification.business_line.company_id ===
              this.companyIdFilter
        )
        .filter(
          (req) =>
            this.atsTypeFilter === null ||
            req.person_specification.ats_type ===
              this.atsTypeFilter
        )
        .filter(
          (req) =>
            this.requisitionStatus === null ||
            req.status === this.requisitionStatus
        ).filter(
          (req) =>
            this.hasCostCenter === null ||
            (this.hasCostCenter && req.cost_center) ||
            (!this.hasCostCenter && !req.cost_center)
        );
    },
    users() {
      return [
        ...new Map(
          this.requisitions.map((req) => [req.creator.id, req.creator])
        ).values(),
      ];
    },
    companies() {
      return [
        ...new Map(
          this.requisitions.map((req) => [
            req.person_specification.business_line.company.id,
            req.person_specification.business_line.company,
          ])
        ).values(),
      ];
    },
    atsTypes() {
      return [
        ...new Map(
          this.requisitions.map((req) => [
            req.person_specification.ats_type,
            req.person_specification.ats_type,
          ])
        ).values(),
      ].sort();
    },
  },

  data() {
    return {
      textFilter: "",
      recruiterIdFilter: null,
      companyIdFilter: null,
      requisitionStatus: null,
      atsTypeFilter: null,
      hasCostCenter: null,
      requisitionStatuses: [
        { id: "expired", title: "Expired" },
        { id: "active", title: "Active" },
      ],
      showModal: false,
      showConvertToRequisitionModal: false,
      jobPipeLineId: ''
    };
  },

  methods: {
    clone(event) {
      if (confirm("Are you sure you want to clone this requisition?")) {
        event.target.parentElement.submit();
      }

      event.returnValue = false;
      return false;
    },

    closingDate(closingDate) {
      return moment(new Date(closingDate)).format("LLL");
    },

    toggleModal(ref) {
      this.$refs[ref].toggleModal()
    },
  },
  mounted() {
    this.requisitionStatus = 'active'
  },
};
</script>

<template>
  <div class="requisitions-table grid-x grid-padding-x grid-padding-y">
    <div class="cell medium-12 filter-by">
        Filter by
    </div>
    <div class="cell auto">
      <div class="grid-x grid-padding-x select-filter-container">
        <div class="cell medium-2">
          <select v-model="requisitionStatus">
            <option :value="null">Status</option>
            <option v-for="status in requisitionStatuses" :value="status.id">
              {{ status.title }}
            </option>
          </select>
        </div>
        <div class="cell medium-3">
          <select v-model="companyIdFilter">
            <option :value="null">Business Unit</option>
            <option v-for="company in companies" :value="company.id">
              {{ company.title }}
            </option>
          </select>
        </div>
        <div class="cell medium-3">
          <select v-model="recruiterIdFilter">
            <option :value="null">Recruiter</option>
            <option v-for="user in users" :value="user.id">
              {{ user.full_name }}
            </option>
          </select>
        </div>
        <div class="cell medium-2">
          <select v-model="atsTypeFilter">
            <option :value="null">ATS Type</option>
            <option v-for="atsType in atsTypes" :value="atsType">
              {{ atsType
              .replace(/_/g, " ")
              .replace(/\w\S*/g, (w) =>
                w.replace(/^\w/, (c) => c.toUpperCase())
              ), }}
            </option>
          </select>
        </div>
        <div class="cell medium-2">
          <select v-model="hasCostCenter">
            <option :value="null">Cost Center</option>
            <option :value="true">With Cost Center</option>
            <option :value="false">Without Cost Center</option>
          </select>
        </div>
      </div>
    </div>

    <div class="cell shrink search-container">
        <input type="text" v-model="textFilter" placeholder="Search (Title)" class="mb-0 search-input" />
        <li class="fas fa-search search-icon"></li>
    </div>

    <div class="cell small-12">
      <table class="mb-4">
        <thead>
          <tr>
            <!-- <th>ID</th> -->
            <th>Title</th>
            <th>Business Unit</th>
            <th>Cost Center</th>
            <th>Line Of Business</th>
            <th>External Requisition Number</th>
            <th class="status">Status</th>
            <th class="status">Preferred Start Date</th>
            <th>ATS Type</th>
            <th>Location</th>
            <!-- <th>Closing Date</th> -->
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="req in filteredRequisitions" :key="req.id">
            <!-- <td>#{{ req.id }}</td> -->
            <td>
              <a
                :href="`/recruiter/active-requisitions/applicants/${req.id}`"
                ><span v-if="req.is_pipeline">[Pipeline]</span> {{ req.person_specification.title }} ({{ req.id }})</a
              >
            </td>
            <td>{{ req.person_specification.business_line.company.title }}</td>
            <td>{{ req.cost_center ? req.cost_center.title : '' }}</td>
            <td>{{ req.person_specification.business_line.title }}</td>
            <td>{{ req.job_profile.external_requisition_number ? req.job_profile.external_requisition_number : '' }}</td>
            <td>{{ req.status }}</td>
            <td>{{ (req.job_profile.sage_job_requisition) ? req.job_profile.sage_job_requisition.preferred_start_date : '' }}</td>
            <td>{{ req.person_specification.ats_type.replace(/(^|_)./g, s => ' '+s.slice(-1).toUpperCase()) }}</td>
            <td><div v-html="req.area"></div></td>
            <td style="text-align:center">
              <a :href="`/recruiter/active-requisitions/applicants/${req.id}`"
                >Applications</a
              >
              <span v-if="req.job" class="divider">|</span>
              <a
                v-if="req.job"
                :href="`/careers/vacancy/${req.job.id}/${req.job.title}`"
                >View</a
              >
              <span class="divider">|</span>
              <form
                :action="`/recruiter/active-requisitions/clone/${req.id}`"
                method="POST"
                style="display: inline-block"
              >
                <input type="hidden" name="_csrfToken" :value="csrfToken" />
                <a href="#" @click="clone">Clone</a>
              </form>
              <span class="divider">|</span>
              <a id="show-modal" @click="showModal = true, reqId = req.id">Check-off</a>
                <Teleport to="body">
                  <!-- use the modal component, pass in the prop -->
                  <modal :show="showModal" :requisitionId="reqId" @close="showModal = false">
                    <template #header>
                      <h5>Choose check-off phase</h5>
                    </template>
                  </modal>
                </Teleport>
              <span class="divider">|</span>
              <a :href="`/recruiter/active-requisitions/fail-bin/${req.id}`">Fail Bin</a>
              <a href="javascript:void()" v-if="req.is_pipeline && (req.status !== 'expired')" @click="toggleModal('convertModal'); jobPipeLineId=req.job.id"> <span class="divider">|</span> Convert to Requisition</a>
              <a href="javascript:void()" v-if="req.is_pipeline && (req.status === 'expired')" class="divider"> <span class="divider">|</span> Convert to Requisition</a>
              <a :href="`/recruiter/active-requisitions/edit/${req.id}`"><span class="divider">|</span> Edit</a>
              <a :href="`/admin/indeed-campaigns/add/${req.id}`">
                <span class="divider">|</span> Indeed
              </a>
              <a :href="`/admin/pnet/pnet-jobs/add/${req.id}`">
                <span class="divider">|</span> Pnet
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <convert-to-requisition-modal ref="convertModal" :job-pipe-line-id="jobPipeLineId" :csrf-token="csrfToken"/>
  </div>
</template>

<style lang="scss">
  #show-modal {
    color: #217FBD;
  }

  .select-filter-container {
        select {
            border: 1px solid #D1D1D1;
            font-size: 13px;
            height: 40px;
            padding: 1px 28px 0 15px;
            -webkit-appearance: none;
            -moz-appearance: none;
            background: url(/img/down-arrow.png) #ffffff;
            background-repeat: no-repeat;
            background-position: 97% 50%;
            background-size: 13px 8px;
        }
    }

    .search-container {
        position: relative;
        display: block;

        .search-input {
            border: 1px solid #D1D1D1;
            font-size: 13px;
            height: 40px;
            padding: 1px 28px 0 15px;
            width: 250px;
            border-radius: 0;

            &::placeholder {
                font-style: italic;
            }
        }

        .search-icon {
            position: absolute;
            font-size: 14px;
            right: 22px;
            top: 24px;
        }
    }

  .requisitions-table {
    .divider {
        color: #D1D1D1;
    }

    .filter-by {
        font-weight: 700;
        font-size: 12px;
        padding-bottom: 0;
        margin-bottom: -8px;
    }

    .font-bold {
        font-weight: bold;
    }

    .mb-0 {
        margin-bottom: 0;
    }

    .mb-1 {
        margin-bottom: 0.25rem;
    }

    p.text-center {
        width: 100%;
        text-align: center;
    }

    table {
        border: 1px solid #D1D1D1;

        thead {
            background-color: #EBEBEB;

            th {
                padding: .65rem 0 .65rem 1rem;
                border-left: 1px solid #D1D1D1;
                color: #455666;
                font-size: 14px;
            }

            th.status {
              width: 5%;
            }
        }

        tbody {
            td {
                // width: 14.285%;
                vertical-align: top;
                border-left: 1px solid #D1D1D1;

                a {
                    text-decoration: none;
                    color: #217FBD;

                    &:hover{
                      text-decoration: underline;
                    }
                }
            }

            tr {
                border-bottom: 1px solid #D1D1D1;
                background: white;
            }
        }
    }
}
</style>